export function cleanTaxId(value: string) {
  return value.replace(/[^0-9]/g, '');
}

export function formatTaxId(value: string) {
  const cleaned = cleanTaxId(value);
  if (cleaned.length >= 3) {
    return cleaned.replace(/^(.{2})(.*)/, '$1-$2');
  }
  return cleaned;
}
